import { render, staticRenderFns } from "./_TopsFlopsView.vue?vue&type=template&id=200e11e6"
import script from "./_TopsFlopsView.vue?vue&type=script&lang=js"
export * from "./_TopsFlopsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports